import React, { useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useField, useFormikContext } from 'formik'

import Dropdown from '../../utils/Dropdown'

import SiteType, { siteTypeOptions } from './SiteType'
import SitesSelector from './SitesSelector/Index'
import Label from '../../utils/Label'
import Input from '../../utils/Input'

import { CheckboxToggleLarge as CheckboxToggle } from '../../utils/CheckboxToggleRemix'

import RequestFormValidationError from './ValidationError'

const electricOptions = [
  {
    label: 'No preference',
    value: ''
  },
  {
    label: '15 amps or more',
    value: '15'
  },
  {
    label: '20 amps or more',
    value: '20'
  },
  {
    label: '30 amps or more',
    value: '30'
  },
  {
    label: '50 amp service',
    value: '50'
  }
]

export const RequestFormStep3 = () => {
  const facility = useSelector(store => store.facilities.facility)
  const requestForm = useFormikContext()
  const type = useMemo(() => requestForm.values.type, [requestForm.values.type])

  const [fieldMinElectric, , { setValue: setValueMinElectric }] = useField('minElectric')
  const [fieldWater, , { setValue: setValueWater }] = useField('water')
  const [fieldSewer, , { setValue: setValueSewer }] = useField('sewer')
  const [fieldPullthru, , { setValue: setValuePullthru }] = useField('pullthru')
  const [fieldSitePremium, , { setValue: setValueSitePremium }] = useField('sitePremium')
  const [fieldIgnoreAda, , { setValue: setValueIgnoreAda }] = useField('ignoreAda')
  const [fieldPetsAllowed, , { setValue: setValuePetsAllowed }] = useField('petsAllowed')
  const [fieldMinLength] = useField('minLength')
  const [fieldSpecificSiteIds] = useField('specificSiteIds')

  const mappedType = useMemo(() => siteTypeOptions.find(option => option.value === type || option.value === Object.keys(facility.sitesDetails.types)[0]), [type])

  const typeDetail = useCallback(
    detailName => mappedType && mappedType.values.some(value => facility.sitesDetails?.typesDetails?.[value]?.[detailName]),
    [mappedType, facility]
  )

  return (
    <div className="mt-1 mb-4">
      <SiteType />

      {facility.sitesDetails && (
        <div className="mt-4 mb-12 grid grid-cols-1 md:grid-cols-3 gap-4 items-end">
          {typeDetail('maxLength') > 0 && (
            <div>
              <Label small>Min Site Length</Label>
              <Input  {...fieldMinLength} />
              <RequestFormValidationError name='minLength' />
            </div>
          )}
          {typeDetail('electric') && (
            <div>
              <Label small>Electric</Label>
              <div>
                <Dropdown
                  options={electricOptions}
                  onChange={option => setValueMinElectric(option.value)}
                  value={fieldMinElectric.value}
                />
              </div>
            </div>
          )}
          {typeDetail('water') && (
            <CheckboxToggle
              label="Water"
              onChange={() => setValueWater(!fieldWater.value)}
              checked={fieldWater.value}
            />
          )}
          {typeDetail('sewer') && (
            <CheckboxToggle
              label="Sewer"
              onChange={() => setValueSewer(!fieldSewer.value)}
              checked={fieldSewer.value}
            />
          )}
          {typeDetail('pullthru') && (
            <CheckboxToggle
              label="PullThru"
              onChange={() => setValuePullthru(!fieldPullthru.value)}
              checked={fieldPullthru.value}
            />
          )}
          {typeDetail('premium') && (
            <CheckboxToggle
              label="Only Premium Sites"
              onChange={() => setValueSitePremium(!fieldSitePremium.value)}
              checked={fieldSitePremium.value}
            />
          )}
          {typeDetail('ada') && (
            <CheckboxToggle
              label="Don't include ADA Sites"
              onChange={() => setValueIgnoreAda(!fieldIgnoreAda.value)}
              checked={fieldIgnoreAda.value}
            />
          )}
          {typeDetail('petsAllowed') && (
            <CheckboxToggle
              label="Pets Allowed"
              onChange={() => setValuePetsAllowed(!fieldPetsAllowed.value)}
              checked={fieldPetsAllowed.value}
            />
          )}
        </div>
      )}
      <SitesSelector />
    </div>
  )
}

export default RequestFormStep3
